
import { Component, Emit, Prop, Vue } from "vue-property-decorator";
import CheckTree from "@/views/ai-builder-v3/components/check-tree.vue";
import ExamV3Custom, {
  ExamV3Tem
} from "@/lib/model/exambuilder/exam-v3/exam-v3";
import draggable from "vuedraggable";
import {
  BasicQuality,
  ColorTest,
  FingerTest,
  GameTest,
  IseChinese,
  IseEnglish,
  PsyUse,
  ObjectiveQuestionScore
} from "@/lib/model/exambuilder/exam-v3/exam-v3-sub";
import { Mind, PsycGaugeConfig } from "@/lib/model/exambuilder/exam-v2";
import Collapse from "@/views/ai-builder-v3/components/collapse.vue";
import QuestionCard from "@/views/ai-builder-v3/components/question-card.vue";
import InputNumberV3 from "@/views/ai-builder-v3/components/inputNumberV3.vue";
import { QuestionV2 } from "@/lib/model/exambuilder/question-v2";

export interface CustomListInspectInfo {
  list: (IseEnglish | IseChinese | BasicQuality)[];
  sort: number;
  name: string;
}

export type InspectSort =
  | CustomListInspectInfo
  | ColorTest
  | FingerTest
  | PsyUse
  | GameTest;

@Component({
  components: {
    CheckTree,
    draggable,
    Collapse,
    QuestionCard,
    InputNumberV3
  }
})
export default class SetQuestion extends Vue {
  @Prop({ type: Object, default: null })
  exam!: ExamV3Custom | ExamV3Tem;
  @Prop({ type: Boolean, default: false }) isEdit!: boolean; //是否编辑页面
  @Prop() userChangeScore!: boolean; // 用户修改过分数
  @Prop({ default: () => [new PsycGaugeConfig()] })
  mindList!: PsycGaugeConfig[]; // 心理测评list

  // emit<{
  //   error: (errorType: 'noInspect' | 'noScoreInspect')
  // }>()

  // 默认顺序:【(英语、普通话、基础素质（默认，自定义）)、辨色检测、心理测评、手部、游戏测评】
  inspectSortList: InspectSort[] = [];
  totalQuestionCount = 0;
  scoreByQuestionList = ["自定义客观题"]; // 按题目配分的考察项名称，万一以后有多个先做成列表
  onlyShowScoreItem = false; // 只看打分项
  startDragInner = false; // 开始拖拽打分的集合
  startDragOuter = false; // 开始拖拽外层
  activeType = 0;
  activeItem = "";
  sortedFlag = false; // 是否已经排过序（用户排序或模板创建）

  pageStatus = false; // 页面加载状态

  get customGroup(): CustomListInspectInfo | null {
    let customGroup: CustomListInspectInfo | null = null;
    this.inspectSortList.forEach(inspect => {
      if (inspect.name === "customGroup") {
        customGroup = inspect as CustomListInspectInfo;
      }
    });
    return customGroup;
  }

  get useFingerTest() {
    // 手部检测至少开启一个检测项，否则认为没开启
    const fingerTest = this.exam.processInformation.physicalInstrument
      .fingerTest;
    return (
      fingerTest.use === 1 &&
      (fingerTest.complete === 1 ||
        fingerTest.flexible === 1 ||
        fingerTest.scar === 1)
    );
  }

  get fingerTestText() {
    const arr: string[] = [];
    this.inspectSortList.forEach(inspect => {
      if (inspect.name === "手部综合检测") {
        if ((inspect as FingerTest).complete === 1) {
          arr.push("手部完整度");
        }
        if ((inspect as FingerTest).flexible === 1) {
          arr.push("灵活度检测");
        }
        if ((inspect as FingerTest).scar === 1) {
          arr.push("疤痕与纹身");
        }
      }
    });
    return "（" + arr.join("、") + "）";
  }

  get questionOrInspectScoreIsZeroList() {
    const list: {
      type: "question" | "inspect";
      item: IseEnglish | IseChinese | BasicQuality | QuestionV2;
    }[] = [];
    this.customGroup?.list.forEach(basic => {
      if (this.scoreByQuestionList.includes(basic.name)) {
        basic.questionList.forEach(question => {
          if (question.totalScore === 0) {
            list.push({ type: "question", item: question });
          }
        });
      } else if (basic.score === 0) {
        list.push({ type: "inspect", item: basic });
      }
    });
    return list;
  }

  getActiveClass(item: IseEnglish | IseChinese | BasicQuality) {
    if (this.activeType === 6 && item.name === "英语口语测试") {
      return "active";
    }
    if (this.activeType === 7 && item.name === "普通话口语测试") {
      return "active";
    }
    if (
      this.activeType === 9 &&
      (item as BasicQuality).dimensionKey === this.activeItem
    ) {
      return "active";
    }
    return "";
  }

  setActive(item: IseEnglish | IseChinese | BasicQuality) {
    if (item.name === "英语口语测试") {
      this.activeType = 6;
      this.activeItem = "英语";
    } else if (item.name === "普通话口语测试") {
      this.activeType = 7;
      this.activeItem = "普通话";
    } else {
      this.activeType = 9;
      this.activeItem = (item as BasicQuality).dimensionKey;
    }
    console.log(this.activeType, this.activeItem);
  }

  handleActive({
    activeType,
    activeItem
  }: {
    activeType: 6 | 7 | 9;
    activeItem: string;
  }) {
    this.activeType = activeType;
    this.activeItem = activeItem;
    let id = activeItem;
    if (activeType !== 9) {
      id = activeItem + "口语测试";
    }
    const ele = document.getElementById(id);
    ele?.scrollIntoView({ block: "center", behavior: "smooth" });
  }

  // 获取心理测评的题目数量
  getPsycQuestionCount(psyc: PsyUse) {
    let count = 0;
    this.mindList.forEach(item => {
      if (item.psycGaugeName === psyc.name && item.psycGaugeId === 1) {
        // 大五人格核心版测评（原名：ocean）题目数量 维度数量 * 12
        count = psyc.psycGaugeSubDimensionIdList.length * 12;
      } else if (item.psycGaugeName === psyc.name && item.psycGaugeId === 4) {
        // 大五人格标准版测评（原名：大五人格心理测评60题版）题目数量 维度数量 * 8
        count = psyc.psycGaugeSubDimensionIdList.length * 8;
      }
    });
    return count;
  }

  created() {
    this.status();
    this.setInspectSortList();
    this.pageStatus = true;
    this.status();
  }

  beforeDestroy() {
    this.setSort();
  }

  unexpandAll() {
    this.customGroup?.list.forEach(basic => {
      basic.active = false;
    });
  }

  dragEnd(e: any) {
    this.startDragOuter = false;
    this.setSort();
  }

  endDragInner(e: any) {
    const customGroup = document.querySelector(".outer-drag .draggable-group");
    const rect = customGroup?.getBoundingClientRect() as DOMRect;
    const groupPageY = rect.top + rect.height;
    const groupAtFirst = this.inspectSortList[0].name === "customGroup";
    if (
      (groupPageY < e.originalEvent.pageY ||
        (rect.top > e.originalEvent.pageY && !groupAtFirst)) &&
      this.inspectSortList.length !== 1 &&
      this.customGroup?.list.length !== 1
    ) {
      this.$message.info("此区域需连续作答，不可打断。");
    }
    this.startDragInner = false;
    this.setSort();
  }

  getQuestionIndex(inspectIndex: number, questionIndex: number) {
    let preTotal = 0;
    this.customGroup?.list.forEach((item, index) => {
      if (inspectIndex > index + 1) {
        preTotal += item.questionList.length;
      } else if (inspectIndex === index + 1) {
        item.questionList.forEach((_, innerQuestionIndex) => {
          if (questionIndex > innerQuestionIndex) {
            preTotal += 1;
          }
        });
      }
    });
    return preTotal + 1;
  }

  getTotalQuestionCount() {
    if (this.customGroup) {
      let totalQuestionCount = 0; // 可配分考察项的题目总数
      this.customGroup.list.forEach(item => {
        totalQuestionCount += item.questionList.length;
      });
      this.totalQuestionCount = totalQuestionCount;
    }
  }

  initScore() {
    // 初始化配分逻辑，前（n-1）为100/n 四舍五入取整，第n个为100 - 前（n-1）的和，用100先算考察项，再用自定义考察项分算自定义题目
    if (this.customGroup) {
      let needScoreInspectCount = 0; // 需要配分考察项总数
      this.customGroup.list.forEach(item => {
        needScoreInspectCount += 1;
      });
      let restScore = 100;
      const beforeN1 = Math.round(100 / needScoreInspectCount);
      this.customGroup.list.forEach(item => {
        // if (item.score !== 0) {
        //   return;
        // }
        needScoreInspectCount--;
        item.score = needScoreInspectCount === 0 ? restScore : beforeN1;
        restScore -= beforeN1;
        if (this.scoreByQuestionList.includes(item.name)) {
          // 按题目配分的考察项
          this.exam.processInformation.objectiveQuestionScoreList.splice(
            0,
            this.exam.processInformation.objectiveQuestionScoreList.length
          );
          const questionBeforeN1 = Math.round(
            item.score / item.questionList.length
          );
          item.questionList.forEach((question, index) => {
            if (index === item.questionList.length - 1) {
              question.totalScore = item.score - questionBeforeN1 * index;
            } else {
              question.totalScore = questionBeforeN1;
            }
            this.exam.processInformation.objectiveQuestionScoreList.push(
              new ObjectiveQuestionScore().assign({
                questionId: question.questionId,
                score: question.totalScore
              })
            );
          });
          this.setInspectByQuestionTotalScore(item.name);
        }
      });
    } else {
      this.$message.warning("没有需要配分的考查项！");
      this.$emit("error", "noScoreInspect");
    }
  }

  setSort() {
    // 约定默认sort从1开始
    let sort = 1;
    this.inspectSortList.forEach(inspect => {
      if (inspect?.name === "customGroup") {
        inspect.sort = sort;
        (inspect as CustomListInspectInfo).list.forEach(basic => {
          basic.sort = sort;
          sort++;
        });
      } else {
        inspect.sort = sort;
        sort++;
      }
    });
    this.change();
  }

  // 目前仅【自定义客观题】可修改题目的分数，自定义客观题维度分数为题目加和
  changeQuestionScore({
    question,
    score
  }: {
    question: QuestionV2;
    score: number;
  }) {
    // 先设置前端结构中对应题目的totalScore
    this.customGroup?.list.forEach(basic => {
      if (this.scoreByQuestionList.includes(basic.name)) {
        basic.questionList.forEach(basicQuestion => {
          if (basicQuestion.questionId === question.questionId) {
            basicQuestion.totalScore = score;
          }
        });
      }
    });
    // 根据每个题目totalScore回设置exam中的考察项分数
    // 目前该emit只提供了这两个参数，没有考察项名称，若以后有多个按题目配分的，还需要考察项名称
    this.setInspectByQuestionTotalScore("自定义客观题");
    // 设置后端结构中的题目分数，结构中没有当前题目id就加一个
    let assignFlag = false;
    this.exam.processInformation.objectiveQuestionScoreList.forEach(
      objectiveQuestionScore => {
        if (objectiveQuestionScore.questionId === question.questionId) {
          objectiveQuestionScore.score = score;
          assignFlag = true;
        }
      }
    );
    if (!assignFlag) {
      this.exam.processInformation.objectiveQuestionScoreList.push(
        new ObjectiveQuestionScore().assign({
          questionId: question.questionId,
          score: score
        })
      );
    }
    this.change();
    this.changeScore();
  }

  // 设置所有按题目配分的考察项总分，传考察项名称则只设置该考察项，默认设置所有按题目配分的考察项
  setInspectByQuestionTotalScore(inspectName?: string) {
    this.exam.processInformation.basicQualityList.forEach(basicQuality => {
      if (inspectName) {
        if (basicQuality.name === inspectName) {
          basicQuality.score = basicQuality.questionList.reduce(
            (pre, cur) => ({ totalScore: pre.totalScore + cur.totalScore }),
            { totalScore: 0 }
          ).totalScore;
        }
      } else {
        if (this.scoreByQuestionList.includes(basicQuality.name)) {
          basicQuality.score = basicQuality.questionList.reduce(
            (pre, cur) => ({ totalScore: pre.totalScore + cur.totalScore }),
            { totalScore: 0 }
          ).totalScore;
        }
      }
    });
  }

  // 默认顺序:【(英语、普通话、基础素质（默认，自定义）)、辨色检测、心理测评、手部、游戏测评】
  setInspectSortList() {
    const processInformation = this.exam.processInformation;
    const psychologicalMotivation = processInformation.psychologicalMotivation;
    // 心理测评以后可能会有多选使用数组结构
    const usePsycList: PsyUse[] = [];
    this.mindList.forEach(psycConfig => {
      const psyUse = psychologicalMotivation["psyc" + psycConfig.psycGaugeId];
      if (psyUse.use === 1) {
        psyUse.name = psycConfig.psycGaugeName;
        psyUse.type = "psyc";
        usePsycList.push(psyUse);
      }
    });
    // 英语，普通话，基础素质在拖拽排序中为一个整体,sort取其最小值
    const english =
      processInformation.knowledgeAndSkills.iseEnglish.use === 1
        ? [processInformation.knowledgeAndSkills.iseEnglish]
        : [];
    const chinese =
      processInformation.knowledgeAndSkills.iseChinese.use === 1
        ? [processInformation.knowledgeAndSkills.iseChinese]
        : [];
    const basicQualityList = processInformation.basicQualityList
      .map(basicQuality => {
        basicQuality.name = basicQuality.dimensionName;
        basicQuality.initSort = basicQuality.sort;
        // 根据题目配分的默认展开
        if (this.scoreByQuestionList.includes(basicQuality.name)) {
          if (this.isEdit) {
            // 编辑模式通过objectiveQuestionScoreList给前端结构回填赋分
            processInformation.objectiveQuestionScoreList.forEach(item => {
              basicQuality.questionList.forEach(question => {
                if (question.questionId === item.questionId) {
                  question.totalScore = item.score;
                }
              });
            });
          }
          // 清除默认值
          if (
            processInformation.objectiveQuestionScoreList.length === 1 &&
            !processInformation.objectiveQuestionScoreList[0].questionId
          ) {
            processInformation.objectiveQuestionScoreList.splice(0, 1);
          }
          // 客观题分数配置缺少了则补充
          if (
            processInformation.objectiveQuestionScoreList.length <
            basicQuality.questionList.length
          ) {
            processInformation.objectiveQuestionScoreList = [];
            basicQuality.questionList.forEach(question => {
              processInformation.objectiveQuestionScoreList.push(
                new ObjectiveQuestionScore().assign({
                  questionId: question.questionId,
                  score: question.totalScore
                })
              );
            });
          }
          basicQuality.active = true;
        }
        return basicQuality;
      })
      .filter(basicQuality => !!basicQuality.dimensionKey);
    // 保证默认的自定义客观题在最后，在选择维度时候排序最好
    if (basicQualityList.length > 1) {
      const i = basicQualityList.findIndex(basic =>
        this.scoreByQuestionList.includes(basic.name)
      );
      if (i >= 0) {
        const c = basicQualityList[i];
        basicQualityList.splice(i, 1);
        basicQualityList.push(c);
      }
    }
    const subGroup = {
      list: [...english, ...chinese, ...basicQualityList].sort(
        (a, b) => a.sort - b.sort
      ),
      sort: 0,
      name: "customGroup"
    };
    this.sortedFlag = subGroup.list.some(item => item.sort !== 0);
    if (this.sortedFlag) {
      subGroup.list.sort((a, b) => Number(a.sort === 0) - Number(b.sort === 0));
    }
    subGroup.sort = subGroup.list[0]?.sort || 0;

    // 设置tree默认激活状态
    if (english.length > 0) {
      this.activeType = 6;
      this.activeItem = "英语";
    } else if (chinese.length > 0) {
      this.activeType = 7;
      this.activeItem = "普通话";
    } else {
      this.activeType = 9;
      this.activeItem = (subGroup.list[0] as BasicQuality).dimensionKey;
    }

    // 辨色，手部、游戏
    const colorTest =
      processInformation.physicalInstrument.colorTest.use === 1
        ? [processInformation.physicalInstrument.colorTest]
        : [];
    const fingerTest = this.useFingerTest
      ? [processInformation.physicalInstrument.fingerTest]
      : [];
    const gameTestList = processInformation.knowledgeAndSkills.gameTestList
      .map(gameTest => {
        gameTest.name = "风险偏好小游戏"; // 目前只有一个游戏，未来有多个应该会从接口中读取游戏名字
        return gameTest;
      })
      .filter(gameTest => !!gameTest.gameTestType);
    // 这里按照默认顺序放
    this.inspectSortList = [
      subGroup,
      ...colorTest,
      ...usePsycList,
      ...fingerTest,
      ...gameTestList
    ].sort((a, b) => a.sort - b.sort);
    if (this.sortedFlag) {
      // 有过排序,将新加的sort为0的放在最后
      this.inspectSortList.sort(
        (a, b) => Number(a.sort === 0) - Number(b.sort === 0)
      );
    }
    console.log(this.inspectSortList);
    if (
      this.inspectSortList.length === 1 &&
      (this.inspectSortList[0] as CustomListInspectInfo).list.length === 0
    ) {
      this.$message.error("请选择考查项！");
      this.$emit("error", "noInspect");
      return;
    }
    this.setInspectByQuestionTotalScore();
    if (!this.isEdit && !this.userChangeScore && !this.exam.templateId) {
      this.initScore();
    }
    this.getTotalQuestionCount();
    this.setSort();
  }

  checkData() {
    const checkTree = this.$refs.checkTree as any;
    if (checkTree) {
      if (checkTree.totalScore !== 100) {
        this.$message.error("请保持总权重为100%");
      }
      return checkTree.totalScore === 100;
    }
    return false;
  }

  @Emit()
  changeScore() {
    // 用户修改过分数
    return this.exam;
  }

  @Emit()
  change() {
    return this.exam;
  }

  @Emit()
  status() {
    return this.pageStatus;
  }
}
